import React from 'react';
import { useNavigate } from 'react-router-dom';
import MovdMarketingHero from '../design-system/MovdMarketingHero.jsx';
import MovdButton from '../design-system/MovdButton.jsx';
import { movdTokens } from '../design-system/movdTokens.js';

const topics = ['Moving Checklists', 'Packing Tips', 'City Guides', 'Cost Calculators', 'Mover Reviews', 'Long Distance Moving', 'Apartment Moves', 'Office Relocation', 'Storage Solutions', 'Moving with Pets'];

export default function BlogPage() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh' }}>
      <MovdMarketingHero eyebrow="Insights & tips" title="Movd blog" subtitle="Moving tips, expert advice, and stories from Canada's most trusted moving platform." />
      <div style={{ maxWidth: 760, margin: '0 auto', padding: 'clamp(24px, 5vw, 48px) 20px', textAlign: 'center' }}>
        <div style={{ padding: 'clamp(32px, 6vw, 56px) 24px', borderRadius: 16, background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)', border: '1px solid #e2e8f0', marginBottom: 40 }}>
          <p style={{ margin: 0, color: movdTokens.color.action.primary, letterSpacing: '.2em', fontSize: 11, fontWeight: 700, textTransform: 'uppercase' }}>Coming soon</p>
          <h2 style={{ margin: '8px 0 16px', fontWeight: 800, fontSize: 26 }}>We&apos;re writing great content</h2>
          <p style={{ margin: '0 0 24px', color: movdTokens.color.content.secondary, fontSize: 16, lineHeight: 1.7, maxWidth: 480, marginLeft: 'auto', marginRight: 'auto' }}>Our blog is launching soon with moving tips, checklists, city guides, and expert advice to make your next move stress-free.</p>
          <MovdButton onClick={() => navigate('/')}>Get a free quote instead</MovdButton>
        </div>
        <p style={{ margin: '0 0 16px', color: movdTokens.color.content.secondary, letterSpacing: '.2em', fontSize: 11, fontWeight: 700, textTransform: 'uppercase' }}>Topics we&apos;ll cover</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, justifyContent: 'center' }}>
          {topics.map(topic => <span key={topic} style={{ border: '1px solid #cbd5e1', borderRadius: 20, padding: '6px 14px', fontSize: 13, color: movdTokens.color.content.secondary }}>{topic}</span>)}
        </div>
      </div>
    </div>
  );
}
